/*
  SalonID — Combipack samenstellen (okt 2026).

  Twee producten kiezen; elk komt data-each keer in de doos. Toevoegen
  stuurt hetzelfde als component-combipack.js: de echte varianten met
  aantal each × combipacks en de eigenschappen "Combipack" (producttitel)
  en "_combipack" (handle:gesorteerde-ids:tijd), zodat de winkelwagen ze
  als één combipack groepeert. Dezelfde variant twee keer = één regel.
*/
(function () {
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var fmt = format || '€{{amount_with_comma_separator}}';
    var parts = value.split('.');
    var thousandsDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var thousandsComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, thousandsDot)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, thousandsComma);
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  var MAX = 2;

  function init(root) {
    if (root.dataset.sidReady) return;
    root.dataset.sidReady = 'true';

    var strings = JSON.parse(root.querySelector('[data-cp-strings]').textContent);
    var each = parseInt(root.dataset.each, 10) || 6;
    var money = function (cents) { return formatMoney(cents, root.dataset.moneyFormat); };
    var storageKey = root.dataset.storageKey;

    var options = {};
    root.querySelectorAll('[data-sb-option]').forEach(function (el) {
      options[el.dataset.sbOption] = {
        el: el,
        id: el.dataset.sbOption,
        label: el.dataset.label,
        price: parseInt(el.dataset.price, 10) || 0,
        img: el.dataset.img || ''
      };
    });

    var els = {
      count: root.querySelector('[data-sb-count]'),
      slots: root.querySelector('[data-sb-slots]'),
      label: root.querySelector('[data-sb-label]'),
      price: root.querySelector('[data-sb-price]'),
      hint: root.querySelector('[data-sb-hint]'),
      submit: root.querySelector('[data-sb-submit]'),
      submitLabel: root.querySelector('[data-sb-submit-label]'),
      error: root.querySelector('[data-sb-error]'),
      packs: root.querySelector('[data-cp-packs]'),
      less: root.querySelector('[data-cp-less]'),
      more: root.querySelector('[data-cp-more]'),
      bar: root.querySelector('[data-sb-bar]'),
      barCount: root.querySelector('[data-sb-bar-count]'),
      barPrice: root.querySelector('[data-sb-bar-price]'),
      barSubmit: root.querySelector('[data-sb-bar-submit]'),
      box: root.querySelector('.sid-sb__box')
    };

    // Vaste balk direct in <body> (zie sid-samplebox.js: secties hebben een transform)
    if (els.bar) {
      var oldBar = document.getElementById(els.bar.id);
      if (oldBar && oldBar !== els.bar) oldBar.remove();
      document.body.appendChild(els.bar);
    }

    var picks = [];
    var packs = 1;
    var busy = false;
    try {
      var saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
      if (Array.isArray(saved.picks)) picks = saved.picks.filter(function (id) { return options[id] && !options[id].el.classList.contains('is-unavailable'); }).slice(0, MAX);
      if (saved.packs > 0) packs = Math.min(99, parseInt(saved.packs, 10) || 1);
    } catch (e) { /* begin leeg */ }

    // ?kies=<variant-id>, vanuit de samplebox (een product dat ze al als sample had):
    // opnieuw beginnen met dat product in het eerste vak; daarna weg uit de url,
    // zodat herladen haar eigen keuze laat staan
    try {
      var url = new URL(window.location.href);
      var chosen = url.searchParams.get('kies');
      if (chosen) {
        if (options[chosen] && !options[chosen].el.classList.contains('is-unavailable')) picks = [chosen];
        url.searchParams.delete('kies');
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      }
    } catch (e) { /* geen URL-api: zoals bewaard */ }

    function save() {
      try { sessionStorage.setItem(storageKey, JSON.stringify({ picks: picks, packs: packs })); } catch (e) { /* negeren */ }
    }

    function perPack() {
      return picks.reduce(function (sum, id) { return sum + options[id].price * each; }, 0);
    }

    function render() {
      var n = picks.length;
      var full = n >= MAX;

      Object.keys(options).forEach(function (id) {
        var o = options[id];
        var qty = picks.filter(function (p) { return p === id; }).length;
        var add = o.el.querySelector('[data-sb-add]');
        var stepper = o.el.querySelector('[data-sb-stepper]');
        if (!add || !stepper) return;
        o.el.classList.toggle('is-picked', qty > 0);
        add.hidden = qty > 0;
        stepper.hidden = qty === 0;
        stepper.querySelector('[data-sb-qty]').textContent = qty;
        add.disabled = full;
        stepper.querySelector('[data-sb-more]').disabled = full;
      });

      els.count.textContent = n === 0 ? strings.countStart : (n === 1 ? strings.countOne : strings.countDone);

      var html = '';
      for (var i = 0; i < MAX; i++) {
        var pick = picks[i] ? options[picks[i]] : null;
        if (pick) {
          html += '<li class="sid-sb__slot">' +
            '<span class="sid-sb__slot-img">' + (pick.img ? '<img src="' + escapeHtml(pick.img) + '" alt="" width="40" height="50">' : '') + '</span>' +
            '<span class="sid-sb__slot-text"><b class="sid-cp__x">' + (each * packs) + '×</b> ' + escapeHtml(pick.label) + '</span>' +
            '<button type="button" class="sid-sb__slot-remove" data-sb-remove="' + i + '" aria-label="' + escapeHtml(strings.remove.replace('[name]', pick.label)) + '">' +
            '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg></button>' +
            '</li>';
        } else {
          html += '<li class="sid-sb__slot is-empty"><span class="sid-sb__slot-n sid-cp__each">' + (each * packs) + '×</span><span class="sid-sb__slot-text">' + escapeHtml(strings.slotFree.replace('[n]', i + 1)) + '</span></li>';
        }
      }
      els.slots.innerHTML = html;

      els.packs.textContent = packs;
      els.less.disabled = packs <= 1;
      els.more.disabled = packs >= 99;

      var total = perPack() * packs;
      if (full) {
        els.label.textContent = packs === 1 ? strings.totalLabel : strings.totalPacks.replace('[n]', packs);
        els.price.textContent = money(total);
        els.price.classList.remove('is-from');
        els.hint.textContent = strings.hintDone.replace('[pieces]', each * MAX * packs);
      } else {
        els.label.textContent = strings.totalLabel;
        els.price.textContent = strings.from.replace('[price]', strings.fromMoney);
        els.price.classList.add('is-from');
        els.hint.textContent = n === 0 ? strings.hintStart : strings.hintOne;
      }

      var canAdd = full && !busy;
      els.submit.disabled = !canAdd;
      els.barSubmit.disabled = !canAdd;
      if (!busy) els.submitLabel.textContent = full ? strings.add.replace('[price]', money(total)) : strings.addEmpty;

      els.barCount.textContent = strings.barCount.replace('[n]', n);
      els.barPrice.textContent = full ? money(total) : '';
      updateBar();
      save();
    }

    function clearError() {
      els.error.hidden = true;
      els.error.textContent = '';
    }

    function focusIfUsable(selector) {
      var target = root.querySelector(selector);
      if (target && !target.disabled && !target.hidden) {
        target.focus();
        return true;
      }
      return false;
    }

    root.addEventListener('click', function (event) {
      var add = event.target.closest('[data-sb-add]');
      var more = event.target.closest('[data-sb-more]');
      var less = event.target.closest('[data-sb-less]');
      var remove = event.target.closest('[data-sb-remove]');
      var option = event.target.closest('[data-sb-option]');

      if ((add || more) && option) {
        if (picks.length < MAX) picks.push(option.dataset.sbOption);
        clearError();
        render();
        var sel = '[data-sb-option="' + option.dataset.sbOption + '"]';
        if (!focusIfUsable(sel + ' [data-sb-more]')) focusIfUsable(sel + ' [data-sb-less]');
      } else if (less && option) {
        var index = picks.lastIndexOf(option.dataset.sbOption);
        if (index > -1) picks.splice(index, 1);
        render();
        if (!picks.includes(option.dataset.sbOption)) focusIfUsable('[data-sb-option="' + option.dataset.sbOption + '"] [data-sb-add]');
      } else if (remove) {
        picks.splice(parseInt(remove.dataset.sbRemove, 10), 1);
        render();
        if (!focusIfUsable('[data-sb-remove]')) els.count.focus();
      }
    });

    els.less.addEventListener('click', function () { if (packs > 1) { packs--; render(); } });
    els.more.addEventListener('click', function () { if (packs < 99) { packs++; render(); } });

    function submit() {
      if (busy || picks.length < MAX) return;
      var quantity = each * packs;
      var ids = picks.map(Number);
      var token = root.dataset.handle + ':' + ids.slice().sort(function (a, b) { return a - b; }).join('+') + ':' + Date.now().toString(36);
      var properties = { 'Combipack': root.dataset.title, '_combipack': token };
      var items = [];
      ids.forEach(function (id) {
        var existing = items.find(function (item) { return item.id === id; });
        if (existing) existing.quantity += quantity;
        else items.push({ id: id, quantity: quantity, properties: properties });
      });

      busy = true;
      clearError();
      els.submit.disabled = true;
      els.barSubmit.disabled = true;
      els.submitLabel.textContent = strings.adding;

      var routes = window.routes || {};
      fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (json) { return { ok: response.ok, json: json }; });
        })
        .then(function (result) {
          if (!result.ok || result.json.status) throw new Error(result.json.description || result.json.message || strings.error);
          picks = [];
          packs = 1;
          busy = false;
          render();
          els.submitLabel.textContent = strings.added;
          setTimeout(function () { if (!busy) render(); }, 2200);
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        })
        .catch(function (error) {
          busy = false;
          render();
          els.error.textContent = (error && error.message) || strings.error;
          els.error.hidden = false;
        });
    }

    els.submit.addEventListener('click', submit);
    els.barSubmit.addEventListener('click', submit);

    var boxVisible = false;
    function updateBar() {
      var show = window.matchMedia('(max-width: 989px)').matches && !boxVisible;
      els.bar.hidden = !show;
      root.classList.toggle('has-bar', show);
    }
    if ('IntersectionObserver' in window && els.box) {
      new IntersectionObserver(function (entries) {
        boxVisible = entries[0].isIntersecting;
        updateBar();
      }, { rootMargin: '0px 0px -40px 0px' }).observe(els.box);
    }
    window.addEventListener('resize', updateBar);

    render();
  }

  function boot() {
    document.querySelectorAll('[data-sid-cp]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
